module.exports = __webpack_public_path__ + "static/img/花瓶1.3962ff0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/reliefVase/imgs/花瓶1.png
// module id = 58oo
// module chunks = 2